// Actions

export const MAP_TYPE = {
  update: () => 'MAP_TYPE_UPDATE'
};

export const FETCH_FEEDBACK_CATEGORIES = {
  request: () => 'FETCH_FEEDBACK_CATEGORIES_REQUEST',
  success: () => 'FETCH_FEEDBACK_CATEGORIES_SUCCESS',
  error: () => 'FETCH_FEEDBACK_CATEGORIES_ERROR'
};

export const SEND_FEEDBACK = {
  request: () => 'SEND_FEEDBACK_REQUEST',
  success: () => 'SEND_FEEDBACK_SUCCESS',
  error: () => 'SEND_FEEDBACK_ERROR'
};
